module.exports = __webpack_public_path__ + "static/assets/e1cd771c352838745c63f7013c726326.png";